<!-- HTML Template -->
<div class="email-container" [formGroup]="emailForm">
  <ng-container *ngIf="isCreate; else updateEmail">
    <div class="email-card">
      <div class="email-header">
        <div class="field-row" *ngIf="!isSms">
          <label>From</label>
          <div class="input-wrapper">
            <input type="text" formControlName="from" />
          </div>
        </div>
        
        <div class="field-row" *ngIf="!isSms">
          <label>To</label>
          <div class="input-wrapper">
            <input type="text" formControlName="to" />
          </div>
          <button class="toggle-btn" (click)="toggleExpand()" aria-label="Toggle CC/BCC fields">
            <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
        
        <div class="optional-fields" [class.hidden]="isExpanded && !isSms">
          <div class="field-row">
            <label>Cc</label>
            <div class="input-wrapper">
              <input type="text" formControlName="cc" />
            </div>
          </div>
          
          <div class="field-row">
            <label>Bcc</label>
            <div class="input-wrapper">
              <input type="text" formControlName="bcc" />
            </div>
          </div>
        </div>
        
        <div class="field-row subject-row" *ngIf="!isSms">
          <div class="input-wrapper">
            <input type="text" formControlName="subject" placeholder="Subject" />
          </div>
        </div>
      </div>
      
      <div class="email-body">
        <app-email
          [lead]="currentLead"
          [allowConvert]="allowConvert"
          [signature]="_signature"
          [isSendingMessage]="isSendingMessage"
          [formControl]="$any(emailForm).get('content')"
          (templateChosen)="newSubject($event)"
          [placeholder]="'Compose your message...'"
          [height]="'240px'"
        ></app-email>
      </div>
    </div>
  </ng-container>

  <ng-template #updateEmail>
    <div class="email-card update-card">
      <app-email
        [lead]="currentLead"
        [signature]="_signature"
        [allowConvert]="allowConvert"
        [isSendingMessage]="isSendingMessage"
        [formControl]="$any(emailForm).get('content')"
        (templateChosen)="newSubject($event)"
        [placeholder]="'Update your message...'"
        [height]="'180px'"
      ></app-email>
    </div>
  </ng-template>
</div>